var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rounded mx-auto opacity-75 px-4 h-8 uppercase font-semibold text-xs z-10 fixed left-0 right-0 bg-white border-gray-100 shadow-md",staticStyle:{"top":"4.5rem"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }